import { render, staticRenderFns } from "./SynonymsRussianLanguagePreview.vue?vue&type=template&id=03f46e2f&lang=pug&"
import script from "./SynonymsRussianLanguagePreview.vue?vue&type=script&lang=js&"
export * from "./SynonymsRussianLanguagePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports